import { EntityTypes } from 'context/entityContext';

import { apiTypeToEntityType } from 'helpers/mapEntityTypes';
import { chartsEventTypes } from 'components/notifications/Settings/utils/createNewSubscription';
import { EventTypes } from 'redux/reducers/subscriptions';

export default getEntityLink;

function getEntityLink(
  entityType: EntityTypes,
  entityId: string,
  artistId: string,
  eventType: EventTypes
): string {
  const type = apiTypeToEntityType(entityType);
  const canBeVersion = type === 'track' || type === 'release';

  if (chartsEventTypes.indexOf(eventType) !== -1) {
    return `/entity/${type}/${entityId}/charts/dsp`;
  }

  if (canBeVersion && !entityId.includes('GRP-')) {
    return `/entity/${type}/${artistId}/version/${entityId}/overview/summary`;
  }

  return `/entity/${type}/${entityId}/overview/summary`;
}
